import { getBasePath } from '../../utils/config';
import { IgetBrandProfileAPIResponse } from './brands.response.interface';

export const getBrandProfileAPI = async (
  brandId: string,
  token: string
): Promise<IgetBrandProfileAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/get_brand_profile?brand_id=${brandId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const createNewBrandAPI = async (
  brand: any,
  clientId: string,
  clientName: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(brand),
  };
  const response = await fetch(
    `${getBasePath()}/client_profile/request_brand?client_name=${clientName}&client_id=${clientId}`,
    params
  );
  const data = await response.json();
  return { response, data };
};
